// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Put not your trust in princes,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;nor in any human power,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for there is no help in them.<br> </p> </div></div>";
// Exports
module.exports = code;